import { useEffect } from 'react';

const singletonKeys = {};

export const useSingleton = (key: string): void => {
    useEffect(() => {
        if (singletonKeys[key]) {
            throw Error('A singleton is being used more than once');
        } else {
            singletonKeys[key] = true;
        }

        return () => {
            delete singletonKeys[key];
        };
    }, [key]);
};
